import { useEffect, useState } from 'react';

import { Box, Button, TextField } from '@mui/material';

/* eslint-disable no-unused-vars */
type ApplicationSearchInputProps = {
  value: string;
  onSearch: (searchText: string) => void;
  onClear: () => void;
};
/* eslint-enable no-unused-vars */

const ApplicationSearchInput = ({ value, onSearch, onClear }: ApplicationSearchInputProps) => {
  const [draft, setDraft] = useState(value);

  useEffect(() => {
    setDraft(value);
  }, [value]);

  const handleSearch = () => {
    onSearch(draft.trim());
  };

  const handleClear = () => {
    setDraft('');
    onClear();
  };

  return (
    <Box display='flex' alignItems='center' gap={1}>
      <TextField
        size='small'
        label='Application Number'
        value={draft}
        onChange={event => setDraft(event.target.value)}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            handleSearch();
          }
        }}
        sx={{ minWidth: 260 }}
      />
      <Button variant='contained' color='primary' onClick={handleSearch}>
        Search
      </Button>
      <Button variant='outlined' color='primary' onClick={handleClear}>
        Clear
      </Button>
    </Box>
  );
};

export default ApplicationSearchInput;
